// Demo Theme Options

import Cookies from 'js-cookie';

$(document).ready(() => {

    var cookiePathFolder = 'fiori-default';

    $('.btn-open-options').click(function () {
        $('.ui-theme-settings').toggleClass('settings-open');
    });

    $('.switch-container-class').on('click', function () {

        var classToSwitch = $(this).attr('data-class');
        var containerElement = '.app-container';
        $(containerElement).toggleClass(classToSwitch);

        $(this).parent().find('.switch-container-class').removeClass('active');
        $(this).addClass('active');

        var finalContainerClass = $(containerElement).attr('class');

        Cookies.set('container-class', finalContainerClass, { path: cookiePathFolder });
    });

    $('.switch-theme-class').on('click', function () {

        var classToSwitch = $(this).attr('data-class');
        var containerElement = '.app-container';

        if (classToSwitch == 'app-theme-white') {
            $(containerElement).removeClass('app-theme-gray');
            $(containerElement).addClass(classToSwitch);
        }

        if (classToSwitch == 'app-theme-gray') {
            $(containerElement).removeClass('app-theme-white');
            $(containerElement).addClass(classToSwitch);
        }

        $(this).parent().find('.switch-theme-class').removeClass('active');
        $(this).addClass('active');

        var finalContainerClass = $(containerElement).attr('class');

        Cookies.set('container-class', finalContainerClass, { path: cookiePathFolder });

    });

    $('.switch-header-cs-class').on('click', function () {
        var classToSwitch = $(this).attr('data-class');
        var containerElement = '.app-header';

        $('.switch-header-cs-class').removeClass('active');
        $(this).addClass('active');

        $(containerElement).attr('class', 'app-header');
        $(containerElement).addClass('header-shadow ' + classToSwitch);

        var finalHeaderClass = $(containerElement).attr('class');

        Cookies.set('header-class', finalHeaderClass, { path: cookiePathFolder });
    });

    $('.switch-topBar-cs-class').on('click', function () {
        var classToSwitch = $(this).attr('data-class');
        var containerElement = '.app-top-bar';

        $('.switch-topBar-cs-class').removeClass('active');
        $(this).addClass('active');

        $(containerElement).attr('class', 'app-top-bar');
        $(containerElement).addClass('' + classToSwitch);

        var finalSidebarClass = $(containerElement).attr('class');

        Cookies.set('topBar-class', finalSidebarClass, { path: cookiePathFolder });
    });

    var containerCookieClass = Cookies.get('container-class');
    var headerCookieClass = Cookies.get('header-class');
    var topBarCookieClass = Cookies.get('topBar-class');

// Default Layout Options

    var containerDefaultClasses = 'app-container app-theme-white';
    var headerDefaultClasses = 'app-header header-shadow';
    var topBarDefaultClasses = 'app-top-bar bg-plum-plate top-bar-text-light';

    if (!containerCookieClass) {
        $('.app-container').attr('class', containerDefaultClasses);
    } else {
        $('.app-container').attr('class', containerCookieClass);
    }

    if (!headerCookieClass) {
        $('.app-header').attr('class', headerDefaultClasses);
    } else {
        $('.app-header').attr('class', headerCookieClass);
    }

    if (!topBarCookieClass) {
        $('.app-top-bar').attr('class', topBarDefaultClasses);
    } else {
        $('.app-top-bar').attr('class', topBarCookieClass);
    }

});